<template>
  <el-card>
    <el-form :inline="true" :model="query">
      <el-form-item label="活动名称">
        <el-input v-model="query.name" placeholder="输入活动名称" />
      </el-form-item>
      <el-form-item label="活动时间">
        <el-date-picker v-model="query.time" type="datetimerange" />
      </el-form-item>
      <el-form-item label="活动状态">
        <el-select v-model="query.status" placeholder="请选择">
          <el-option label="未开始" value="1" />
          <el-option label="进行中" value="2" />
          <el-option label="已结束" value="3" />
        </el-select>
      </el-form-item>
      <el-button type="primary" @click="fetchList">查询</el-button>
      <el-button @click="reset">重置</el-button>
    </el-form>
    <el-button type="primary" style="margin:10px 0" @click="goToAdd">新增活动</el-button>
    <el-table :data="list" border>
      <el-table-column type="selection" width="50" />
      <el-table-column prop="activityCode" label="活动编号" />
      <el-table-column prop="activityTitle" label="活动名称" />
      <el-table-column prop="activityTypeName" label="活动类型" />
      <el-table-column prop="startDate" label="开始时间" :formatter="formatTime" />
      <el-table-column prop="endDate" label="结束时间" :formatter="formatTime" />
      <el-table-column label="状态">
        <template #default="{ row }">
          <el-tag :type="statusTypeByName(row.activityStatusName)">
            {{ row.activityStatusName }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="320" fixed="right">
        <template #default="{ row }">
          <el-button type="primary" @click="pushNewAct(row)">编辑</el-button>
          <el-button type="primary" @click="watchAct(row)">查看</el-button>
          <el-button
            v-if="showEnd(row)"
            type="primary" @click="endAct(row)">结束</el-button>
          <el-button
            v-if="row.activityStatus!==3"
            type="primary" @click="copyAct(row)">复制链接</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      style="margin-top:10px"
      layout="prev, pager, next"
      :total="total"
      v-model:current-page="query.page"
      @current-change="fetchList"
    />
  </el-card>
</template>


<script setup lang="ts">
import { ref, reactive } from 'vue'

import {dateUtil, onActivated, useCurrentAppInstance} from '@zto/zpage'
import {ElMessage, ElMessageBox} from "element-plus";
import {setClipboardText} from "@/utils";
const app = useCurrentAppInstance()
const query = reactive({ name: '', status: '', time: [], page: 1 })
const list = ref<any[]>([])
const total = ref(0)

const formatTime = (_row: any, _column: any, cellValue: string) => {
  if (!cellValue) return '-'
  return dateUtil.parseAndFormat(cellValue)
}

const showEnd =(row:any)=>{
  const result= !(row.activityStatus===3 || row.activityStatus===1)
  return result
}

const goToAdd = () => {
  // 路由跳转到新增页
  app.router.goto({
    title: '新增活动',
    name: '',
    path: '/activitynew',
    query: {
      operateType: 'add'
    }
  })
};

const statusTypeByName = (name: string) => {
  if (!name) return 'info'
  if (name.includes('未开始')) return 'info'
  if (name.includes('进行中')) return 'success'
  if (name.includes('结束')) return 'danger'
  return ''
}

const statusType = (status: number | string) => {
  switch (String(status)) {
    case '0':
      return 'info'    // 未开始：灰色
    case '1':
      return 'success' // 进行中：绿色
    case '2':
      return 'warning' // 即将结束
    case '3':
      return 'danger'  // 已结束 / 已下线
    default:
      return ''
  }
}

const copyAct=(item:any)=>{
  setClipboardText(`pages/activity/index?activityCode=${item.activityCode}`)
  ElMessage.success('复制成功');
}

const pushNewAct=(item:any)=>{
  app.router.goto({
    title: '编辑活动',
    name: 'activitynew',
    path: '/activitynew',
    query: {
      id: item.id,
      activityCode:item.activityCode,
      type:'edit'
    }
  })
}

const endAct=(item:any)=>{
  ElMessageBox.confirm(
    '确定要结束这个活动吗？',
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
    .then(() => {
      // 👉 点【确定】
      app.request({
        api: 'admin/activity/end',
        params: {
          activityCode:item.activityCode
        }
      }).then(()=>{
        ElMessage.success('操作成功')
        fetchList()
      })
    })
    .catch(() => {
      // 👉 点【取消】或关闭
      ElMessage.info('已取消操作')
    })

}

const watchAct=(item:any)=>{
  app.router.goto({
    title: '查看',
    name: 'activitynew',
    path: '/activitynew',
    query: {
      id: item.id,
      activityCode:item.activityCode,
      type:'view'
    }
  })
}

const fetchList = async () => {
  const res = await app.request({
    api: 'admin/activity/queryList',
    params: {
      pageSize:100,
      pageIndex:1,
      activityStatus:query.status,
      activityTitle:query.name,
      startTimeBegin:(query.time &&query.time[0])? dateUtil.parseAndFormat(query.time[0]):'',
      startTimeEnd:(query.time &&query.time[1])? dateUtil.parseAndFormat(query.time[1]):'',
    }
  })
  list.value = res.data
  total.value = res.total
}


const reset = () => {
  query.name = ''
  query.status = ''
  query.time = [] as any
  fetchList()
}


onActivated(() => {
  reset()
})

fetchList()
</script>
